import { render, staticRenderFns } from "./monthTopic.vue?vue&type=template&id=3ce88bc6&scoped=true&"
import script from "./monthTopic.vue?vue&type=script&lang=js&"
export * from "./monthTopic.vue?vue&type=script&lang=js&"
import style0 from "./monthTopic.vue?vue&type=style&index=0&id=3ce88bc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce88bc6",
  null
  
)

export default component.exports